export const TEST_ID = 'logServicePanel';

export const NOTES_MAX_LENGTH = 500;

export const PART_SERIAL_NUMBER_MAX_LENGTH = 40;

export const MAX_PHOTOS = 6;
